:host {
  --scrollbar-width: 0px;
}
